import React, { Component } from 'react'
import LocalStorageKeys from '../../cache/LocalStorageKeys'
import ThemeUI from './ThemeUI.js'

class ThemeSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    };

    this.onThemeClick = this.onThemeClick.bind(this)
  }

  render() {
    return (
      <ThemeUI
        context={this.props.context}
        onThemeClick={this.onThemeClick}
      />
    );
  }

  onThemeClick(event) {
    event.preventDefault()
    let theme = event.target.getAttribute('data-theme')
    console.log(theme)

    if (theme !== 'lite' && theme !== 'dark') {
      console.log('theme not supported')
      return
    }

    document.body.classList.remove('lite')
    document.body.classList.remove('dark')
    document.body.classList.add(theme)
    localStorage.setItem(LocalStorageKeys.Theme, theme)

    let context = this.props.context
    context.theme = theme
    console.log(context)
    context.onContextChange(context)
  }
}

export default ThemeSF
